import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { FormControl, Paper } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledPaper = styled(Paper)(({ theme }) => ({
  fontFamily: "Inter, sans-serif",
  whiteSpace: "normal",
  wordWrap: "break-word",
  "& .MuiAutocomplete-listbox": {
    display: "flex",
    flexDirection: "column",
    gap: "5px",
    padding: "7px",
  },
  "& .MuiAutocomplete-option": {
    whiteSpace: "normal",
    lineHeight: 1.4,
    fontSize: "13px",
    backgroundColor: "#F2F2F2",
    borderRadius: "4px",
    fontFamily: "Inter, sans-serif",
    "&:hover": {
      backgroundColor: "#E0E0E0",
    },
  },
}));

const MDAutoComplete = ({
  options = [],
  value,
  onChange,
  onInputChange,
  label,
  disabled = false,
  error = false,
  helperText = "",
  fullWidth = false,
  sx = {},
  ...otherProps
}) => {
  return (
    <FormControl variant="outlined" fullWidth>
      <Autocomplete
        options={options}
        value={value}
        onChange={onChange}
        onInputChange={onInputChange}
        fullWidth={fullWidth}
        disabled={disabled}
        disableClearable={!value}
        forcePopupIcon={false}
        PaperComponent={StyledPaper}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={label}
            error={error}
            helperText={helperText}
            sx={{
              "& .MuiOutlinedInput-root": { borderRadius: "10px" },
              "& .MuiOutlinedInput-input": {
                padding: "12px 14px",
                fontSize: "14px",
              },
              "& .MuiFormHelperText-root": { minHeight: "20px" },
              ...sx,
            }}
          />
        )}
        renderOption={(props, option, { index }) => (
          <li {...props} key={`${option}-${index}`}>
            {option}
          </li>
        )}
        {...otherProps}
      />
    </FormControl>
  );
};

export default MDAutoComplete;
